// Swiper functionality
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initSwipers() {
    // Initialize all swipers with default configuration
    const swiperElements = document.querySelectorAll('.swiper');

    swiperElements.forEach((element) => {
        const swiperEl = element as HTMLElement;

        // Get configuration from data attributes or use defaults
        let slidesPerView: number | 'auto' = 1;
        const slidesPerViewAttr = swiperEl.dataset.slidesPerView;

        if (slidesPerViewAttr === 'auto') {
            slidesPerView = 'auto';
        } else if (slidesPerViewAttr) {
            slidesPerView = parseInt(slidesPerViewAttr);
        }

        const loop = swiperEl.dataset.loop === 'true';

        const config = {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: slidesPerView,
            spaceBetween: parseInt(swiperEl.dataset.spaceBetween || '30'),
            loop: loop,
            autoplay: swiperEl.dataset.autoplay === 'true' ? {
                delay: parseInt(swiperEl.dataset.autoplayDelay || '3000'),
                disableOnInteraction: false,
            } : false,
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next') as HTMLElement,
                prevEl: swiperEl.querySelector('.swiper-button-prev') as HTMLElement,
            },
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination') as HTMLElement,
                clickable: true,
                renderBullet: function (index: number, className: string) {
                    return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
                },
            },
            watchOverflow: true,
            observer: true,
            observeParents: true,
        };

        new Swiper(swiperEl, config);
    });
}

